// Components
import { PerformanceDashboardScreen } from "./performance-dashboard.component";

export default PerformanceDashboardScreen;
